import React from 'react'
import { BarLoader } from 'react-spinners'
import { loadingSpinner } from './loading.module.scss'

const LoadingSpinner = () => {
  return (
    <div className={loadingSpinner}>
      <BarLoader color='#004495' />
    </div>
  )
}

export default LoadingSpinner
